import React from 'react'

const UnderDevlopment = () => {
  return (
    <div className='flex jcc aic '
    style={{height:"100%",width:"100%", fontSize:"24px", fontWeight:"bold"}}>Under Devlopment</div>
  )
}

export default UnderDevlopment